<template>
  <div>
    <!--<b-overlay :show="isLoading" rounded="sm" spinnerVariant="primary"> -->
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-2 pt-3 pb-3 d-flex align-items-center page-header" ref="pageHeader">
      <div class="col">
        <div class="text-nowrap">
          <h4>
            <b-icon class="me-2" icon="calculator" @click="downloadAsXLS"></b-icon>
            Projektbudget
          </h4>
        </div>
        <!-- <div class="text-uppercase text-secondary"><small>Kostenkontrolleinheiten</small></div> -->
      </div>
      <div class="col-auto">
        <div class="form-inline">
          <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
          <!-- Neue Kontrolleinheit -->
          <b-button size="sm" variant="light" class="" @click="scrollToNewRowAndFocus()" v-if="canChange">
            <b-icon icon="plus" variant="dark" class="mr-1"></b-icon>
            Kontrolleinheit
          </b-button>
          <b-button
            :disabled="!isDeleteButtonEnabled"
            size="sm"
            variant="light"
            class="ml-2"
            @click="deleteSelected()"
            v-if="canChange"
          >
            <b-icon icon="trash" variant="dark" class="mr-1"></b-icon>
            Löschen
          </b-button>
          <b-button size="sm" variant="light" class="ml-2">
            <b-icon @click="loadCostGroups" icon="arrow-repeat" variant="dark" class=""></b-icon>
          </b-button>

          <!-- SEARCH FIELD  -->
          <b-input-group class="ml-2 header-search-field">
            <b-form-input
              type="search"
              size="sm"
              v-model.lazy="searchText"
              :class="{ 'bg-primary-light-3': searchText !== '' }"
              placeholder="Suchbegriff eingeben..."
            ></b-form-input>
            <template #prepend>
              <b-input-group-text>
                <b-icon variant="dark" icon="search" />
              </b-input-group-text>
            </template>
          </b-input-group>
          <!-- FILTER BUTTON  -->
          <b-button
            size="sm"
            :variant="filterToggle == true ? 'primary' : 'light'"
            class="ml-2"
            :pressed="filterToggle"
            :disabled="!isDeleteButtonEnabled"
            @click="filterRecords"
          >
            <b-icon icon="funnel"></b-icon>
          </b-button>
          <!-- HELP ICON  -->
          <b-button
            size="sm"
            variant="light"
            class="ml-2"
            href="https://www.bauvisor.de/projektbudget-2/"
            target="_blank"
          >
            <b-icon icon="question-circle" variant="dark" class=""></b-icon>
          </b-button>
          <!-- BUTTON: DROPDOWN WEITERE AKTIONEN  -->
          <b-dropdown
            size="sm"
            variant="light"
            toggle-class="text-decoration-none"
            no-caret
            right
            class="ml-2"
            v-if="$root.$user.isPlaner || $root.$user.isAdmin"
          >
            <template #button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="showMultiAllocationModal" :disabled="!isDeleteButtonEnabled">
              <b-icon icon="diagram3" rotate="180" class="mr-1" />
              Ausgewählte KKE einer VE zuweisen
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
              @click="showImportKKEModal"
              v-if="
                projectStore
                  ? projectStore.activeProject.State == 0 && ($root.$user.isPlaner || $root.$user.isAdmin)
                  : false
              "
            >
              <b-icon icon="cloud-upload" class="mr-1" />
              Budget aus Excel importieren
            </b-dropdown-item>
            <b-dropdown-divider v-if="projectStore ? projectStore.activeProject.State == 1 : false" />
            <b-dropdown-item
              href="#"
              @click="revertProjectStart"
              v-if="
                projectStore
                  ? projectStore.activeProject.State == 1 && ($root.$user.isPlaner || $root.$user.isAdmin)
                  : false
              "
            >
              <b-icon icon="exclamation-circle" rotate="180" class="mr-1" />
              Projektphase zurückstellen
            </b-dropdown-item>
          </b-dropdown>
          <b-button size="sm" variant="primary" class="ml-2 text-light" @click="startProject" v-if="canChange">
            <b-icon icon="play" variant="light" class="mr-1"></b-icon>
            Projektphase wechseln
          </b-button>
        </div>
      </div>
    </div>

    <div class="main-canvas" style="position: relative">
      <div v-if="isLoading" style="" class="d-flex justify-content-center mb-3 loading-spinner-wrapper">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
      <BudgetSummaryWidget />
      <div class="table-sticky-header-hack"></div>
      <b-form ref="newCostGroupRowForm" id="newCostGroupRowForm">
        <b-table
          hover
          small
          :filter="searchText"
          :filter-included-fields="['Ordinal', 'DisplayName']"
          bordered
          :sticky-header="tableHeight"
          class="bg-white costGroupTable sum-header shadow-muted-super"
          :items="costGroups"
          :fields="costGroupsFields"
          :busy="isCostGroupsTableBusy"
          head-variant="light"
          ref="tableCostGroups"
          show-empty
          :responsive="true"
          @filtered="handleFilterChange"
          fixed
        >
          <template #empty>
            <div class="block text-center text-muted p-5">Keine Kostenkontrolleinheiten vorhanden.</div>
          </template>
          <template #head(checked)>
            <b-form-checkbox
              class="ml-2"
              v-model="checkedAllCostGroups"
              @change="onCheckAllCostGroupsChange"
              :disabled="
                costGroups.length == 0 /* || costGroups.reduce((acc, cur) => acc + (cur.Locked ? 0 : 1), 0) == 0 */
              "
            ></b-form-checkbox>
          </template>
          <template #head(Budget)="data">
            <div style="padding-right: 11px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey"
              :class="{ 'text-primary': searchText != '' || filterToggle }"
            >
              <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
              {{ formatCurrency(costGroupsTotal) }}
            </div>
          </template>
          <template #head(BudgetAllocated)="data">
            <div style="padding-right: 11px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey"
              :class="{ 'text-primary': searchText != '' || filterToggle }"
            >
              <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
              {{ formatCurrency(costGroupsTotalAllocated) }}
            </div>
          </template>
          <template #head(BudgetSaldo)="data">
            <div style="padding-right: 11px">
              {{ data.label }}
            </div>
            <div
              class="font-weight-bold text-right text-grey"
              :class="{ 'text-primary': searchText != '' || filterToggle }"
            >
              <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
              {{ formatCurrency(costGroupsTotal - costGroupsTotalAllocated) }}
            </div>
          </template>

          <template #cell(checked)="data">
            <b-form-checkbox
              @change="onCheckCostGroupItemChange(data.item)"
              v-model="data.item.checked"
              :disabled="data.item.editMode"
              class="ml-2"
            ></b-form-checkbox>
          </template>
          <template #cell(Locked)="data">
            <b-icon icon="lock" style="color: #aaa" v-show="data.item.Locked" title="Diese KKE ist gesperrt." />
          </template>
          <template #cell(Ordinal)="data">
            <div
              @click="toggleRowEdit(data.item, 'ordinalField')"
              style="padding-left: 5px; padding-right: 5px"
              v-show="!data.item.editMode || data.item.Locked"
            >
              {{ data.item.Ordinal }}
            </div>
            <input
              :required="data.item.editMode && !data.item.Locked"
              v-show="data.item.editMode && !data.item.Locked"
              v-model.lazy="data.item.Ordinal"
              class="form-control table-input-field px-2"
              :ref="'ordinalField-' + data.item.DbId"
              @keyup.esc="cancelRowEdit(data.item)"
              @keyup.enter="updateCostGroupItem(data.item)"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
              maxlength="50"
            />
          </template>
          <template #cell(DisplayName)="data">
            <div
              @click="toggleRowEdit(data.item, 'displayNameField')"
              style="padding-left: 5px; padding-right: 5px; max-width: 500px; word-wrap: break-word"
              v-show="!data.item.editMode"
            >
              {{ data.item.DisplayName && data.item.DisplayName != '' ? data.item.DisplayName : ' ' }}
            </div>
            <input
              :required="data.item.editMode && !data.item.Locked"
              v-show="data.item.editMode"
              v-model.lazy="data.item.DisplayName"
              class="form-control table-input-field px-2"
              :ref="'displayNameField-' + data.item.DbId"
              @keyup.esc="cancelRowEdit(data.item)"
              @keyup.enter="updateCostGroupItem(data.item)"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
              maxlength="100"
            />
          </template>
          <template #cell(Budget)="data">
            <div
              @click="toggleRowEdit(data.item, 'budgetField')"
              style="padding-right: 5px"
              v-show="!data.item.editMode || data.item.Locked"
            >
              {{ formatCurrency(data.item.Budget) }}
            </div>
            <input
              :required="data.item.editMode && !data.item.Locked"
              :ref="'budgetField-' + data.item.DbId"
              type="number"
              lang="de"
              min="0"
              step="0.01"
              pattern="^\d+(?:\.\d{1,2})?$"
              v-show="data.item.editMode && !data.item.Locked"
              v-model.lazy="data.item.Budget"
              class="form-control table-input-field text-right px-2"
              @keyup.esc="cancelRowEdit(data.item)"
              @keyup.enter="updateCostGroupItem(data.item)"
              @keydown.tab.prevent.stop="$refs['ordinalField-' + data.item.DbId].focus()"
              @blur="handleCellLeave"
              @change="rowIsDirty = data.item"
            />
          </template>

          <template #cell(BudgetAllocated)="data">
            <div @click="navigateTo(data.item)">
              {{ formatCurrency(data.item.BudgetAllocated) }}
            </div>
          </template>
          <template #cell(BudgetSaldo)="data">
            <div @click="navigateTo(data.item)">
              {{ formatCurrency(data.item.BudgetSaldo) }}
            </div>
          </template>
          <template #custom-foot="">
            <!---------------------------------
                    NEW RECORD ROW
                ---------------------------------->
            <b-tr style="border-top: 2px solid #dee2e6; border-bottom: 2px solid #dee2e6" v-if="canChange">
              <b-td class="py-0 align-middle table-edit-field" style="padding-left: 14px">
                <b-icon
                  icon="plus-circle"
                  variant="grey"
                  class="action-button"
                  @click="$refs.newCostGroupRowKKE.focus()"
                />
              </b-td>
              <b-td class="table-edit-field"></b-td>
              <b-td class="p-0">
                <!-- FELD "KKE" -->
                <b-input
                  placeholder="KKE"
                  type="text"
                  class="border-0 shadow-none table-edit-field px-1"
                  v-model.lazy="rowDataNewCostGroup.Ordinal"
                  ref="newCostGroupRowKKE"
                  required
                  @keyup.enter="insertNewRecord"
                  maxlength="50"
                />
              </b-td>
              <b-td class="p-0">
                <!-- FELD: BEZEICHNUNG  -->
                <b-input
                  placeholder="Bezeichnung"
                  type="text"
                  class="border-0 shadow-none table-edit-field px-1"
                  v-model.lazy="rowDataNewCostGroup.DisplayName"
                  required
                  @keyup.enter="insertNewRecord"
                  maxlength="100"
                />
              </b-td>

              <b-td class="p-0">
                <!-- FELD: BUDGET  -->
                <b-input
                  placeholder="Budget"
                  type="number"
                  lang="de"
                  class="border-0 shadow-none table-edit-field text-right px-1"
                  v-model.lazy="rowDataNewCostGroup.Budget"
                  @keyup.enter="insertNewRecord"
                  required
                  min="0"
                  step="0.01"
                  pattern="^\d+(?:\.\d{1,2})?$"
                  @keydown.tab.prevent.stop="$refs.newCostGroupRowKKE.focus()"
                />
              </b-td>
              <b-td class="bg-light text-right align-middle text-muted">{{ formatCurrency(0.0) }}</b-td>
              <b-td class="bg-light text-right align-middle text-muted">{{ formatCurrency(0.0) }}</b-td>
              <!---------------------------------
                    NEW RECORD ROW - ADD NOW BUTTON
                  ---------------------------------->
              <b-td class="p-0 text-center align-middle table-edit-field">
                <b-icon icon="check2" variant="grey" class="action-button" @click="insertNewRecord" />
              </b-td>
            </b-tr>

            <!---------------------------------
                    SUMMARY ROW
                ---------------------------------->
            <b-tr>
              <b-td colspan="4">
                <span class="float-right">Gesamtbudget:</span>
                <div class="text-muted small " style="margin-left:9px; margin-top:2px;" v-if="!isLoading">
                  {{ displayedItemsCount }} Zeilen dargestellt, {{ selectedRows.length }} Zeilen ausgewählt.
                </div>
              </b-td>

              <b-td class="text-right font-weight-bold text-nowrap">{{ formatCurrency(costGroupsTotal) }}</b-td>
            </b-tr>
          </template>
          <!---------------------------------
                    TABLE ENTRY ACTIONS
                ---------------------------------->
          <template #cell(actions)="data">
            <!-- O P E N   B U D G E T -->
            <svg
              v-show="!data.item.editMode"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="currentColor"
              class="mr-2 text-grey action-button"
              viewBox="0 0 16 16"
              style="margin-bottom: 2px"
              @click.stop="navigateTo(data.item)"
            >
              <path
                d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"
              />
            </svg>
            <!--- E D I T  --->
            <b-icon
              v-show="!data.item.editMode && projectStore.activeProject.State == 0"
              icon="pencil"
              class="mr-2 action-button"
              variant="grey"
              @click="toggleRowEdit(data.item)"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            ></b-icon>
            <!--- D E L E T E  --->
            <b-icon
              v-show="!data.item.editMode && projectStore.activeProject.State == 0"
              icon="trash"
              variant="grey"
              class="action-button"
              @click="deleteCostGroup(data.item)"
              v-if="$root.$user.isPlaner || ($root.$user.isAdmin && !data.item.Locked)"
            ></b-icon>
            <!--- D E L E T E     only visible, if kke is locked  --->
            <b-icon
              icon="trash"
              variant="grey"
              style="width: 16px; height: 16px; cursor: not-allowed; color: #ddd"
              title="Kostenkontrolleinheit ist gesperrt."
              v-show="
                !data.item.editMode &&
                  projectStore.activeProject.State == 0 &&
                  data.item.Locked &&
                  ($root.$user.isPlaner || $root.$user.isAdmin)
              "
            />

            <!--- A C C E P T   ACTION: ONLY VISIBLE, IF ENTRY IS IN EDIT MODE --->
            <b-icon
              v-show="data.item.editMode"
              title="Bearbeiten"
              icon="check2"
              variant="grey"
              class="action-button mr-2"
              @click="updateCostGroupItem(data.item)"
            ></b-icon>
            <!--- C A N C E L   ACTION: ONLY VISIBLE, IF ENTRY IS IN EDIT MODE --->
            <b-icon
              v-show="data.item.editMode"
              title="Bearbeiten abbrechen"
              icon="x"
              variant="grey"
              class="action-button"
              @click="cancelRowEdit(data.item)"
            ></b-icon>
          </template>
        </b-table>
      </b-form>
    </div>
    <!------------------------
          MODAL DIALOGS
    -------------------------->

    <ImportKKEModal @success="onImportSuccess" @error="loadCostGroups()" />
    <MultiAllocationModal @ok="bookMultiAllocations" />
    <!-- </b-overlay> -->
  </div>
</template>
<script>
import { getInstance } from '../auth';
import projectStore from '@/store/Projects';
import settingsStore from '@/store/Settings';
import costGroupService from '@/service/CostGroupsService';
import projectService from '@/service/ProjectsService';
import ImportKKEModal from '@/components/budget/ImportKKEDialog';
import MultiAllocationModal from '@/components/budget/MultiAllocationDialog';
import BudgetSummaryWidget from '@/components/BudgetSummaryWidget';
import AppState from '@/store/App.js';

export default {
  mounted() {
    this.loadCostGroups();
  },
  computed: {
    canChange() {
      return (
        (projectStore ? projectStore.activeProject.State == 0 : false) &&
        (this.$root.$user.isPlaner || this.$root.$user.isAdmin)
      );
    }
  },
  created() {
    this.$eventBus.$on('projectSwitched', () => {
      this.searchText = '';
    });
  },
  activated() {
    window.addEventListener('resize', this.onWindowResize, false); // listen for windows size changes, to re-compute height of controls
    this.isLoading = true;
    this.loadCostGroups();
    AppState.isLoading = false;
    /*
    var thElm;
    var startOffset;

    Array.prototype.forEach.call(document.querySelectorAll('table th'), function(th) {
      th.style.position = 'relative';

      var grip = document.createElement('div');
      grip.innerHTML = '&nbsp;';
      grip.style.top = 0;
      grip.style.right = '-2px';
      grip.style.bottom = 0;
      grip.style.width = '4px';
      grip.style.position = 'absolute';
      grip.style.cursor = 'col-resize';
      grip.style.zIndex = 1000;
      grip.classList.add('noselect');
      grip.addEventListener('mousedown', function(e) {
        thElm = th;
        startOffset = th.offsetWidth - e.pageX;
      });

      th.appendChild(grip);
    });

    document.addEventListener('mousemove', function(e) {
      if (thElm) {
        thElm.style.width = startOffset + e.pageX + 'px';
      }
    });

    document.addEventListener('mouseup', function() {
      thElm = undefined;
    });
    */
  },
  beforeRouteLeave(to, from, next) {
    AppState.scrollPosition[from.path] = [
      this.$refs.tableCostGroups.$el.scrollTop,
      this.$refs.tableCostGroups.$el.scrollLeft
    ];
    next();
  },
  deactivated() {
    window.removeEventListener('resize', this.onWindowResize, false);
  },
  components: {
    ImportKKEModal,
    BudgetSummaryWidget,
    MultiAllocationModal
  },
  data() {
    return {
      selectedRows: [],
      filterToggle: false,
      rowIsDirty: null,
      costGroups: [],
      displayedItemsCount: null,
      costGroupsFields: [
        {
          key: 'checked',
          label: '',
          tdClass: 'text-center align-middle',
          thClass: 'text-center align-top noselect',
          thStyle: 'width: 45px'
        },
        {
          key: 'Locked',
          label: ' ',
          thStyle: 'width: 30px',
          thClass: 'align-top noselect',
          tdClass: 'text-center align-middle p-0',
          sortable: true
        },
        {
          key: 'Ordinal',
          label: 'KKE',
          thClass: 'align-top noselect',
          tdClass: 'align-middle p-0',
          sortable: true
        },
        {
          key: 'DisplayName',
          label: 'Bezeichnung',
          thClass: 'align-top noselect',
          thStyle: 'width:35%',
          tdClass: 'align-middle p-0',
          sortable: true
        },
        {
          key: 'Budget',
          label: 'Budget',
          tdClass: 'text-right align-middle p-0 text-nowrap',
          thClass: 'align-top text-right noselect  text-nowrap',
          thStyle: 'padding-right: 5px;',
          formatter: x => this.$utils.numberToCurrency(x, settingsStore.settings['Centbetraege']),
          sortable: true
        },
        {
          key: 'BudgetAllocated',
          label: 'Zugewiesen',
          tdClass: 'text-right align-middle action-button text-nowrap',
          thClass: 'align-top text-right noselect text-nowrap',
          thStyle: 'padding-right: 5px;',
          formatter: x => this.$utils.numberToCurrency(x, settingsStore.settings['Centbetraege']),
          sortable: true
        },
        {
          key: 'BudgetSaldo',
          label: 'Restbudget',
          thClass: 'align-top text-right noselect',
          tdClass: 'text-right align-middle action-button text-nowrap',
          thStyle: 'padding-right: 5px;',
          formatter: x => this.$utils.numberToCurrency(x, settingsStore.settings['Centbetraege']),
          sortable: true
        },
        {
          key: 'Actions',
          label: 'Aktionen',
          thStyle: 'width:90px',
          tdClass: 'text-center align-middle',
          thClass: 'align-top noselect'
        }
      ],
      checkedAllCostGroups: false,
      isCostGroupsTableBusy: true,
      costGroupsTotal: 0,
      costGroupsTotalAllocated: 0,
      allocationUnitsTotal: 0,
      projectStore,
      isBusy: false,
      isLoading: true,
      isDeleteButtonEnabled: false,
      rowDataNewCostGroup: {
        Ordinal: '',
        DisplayName: '',
        Budget: null
      },
      rowDataBackup: {},
      searchText: '',
      tableHeight: '500px'
    };
  },

  methods: {
    handleFilterChange(visibleItems) {
      // remove check from all non-visible fields
      const checkItems = this.costGroups.filter(x => x.checked == true);
      checkItems.forEach(item => {
        if (visibleItems.findIndex(x => x.DbId == item.DbId) == -1) {
          item.checked = false;
          // also remove from selected rows
          const index = this.selectedRows.findIndex(x => x.DbId == item.DbId);
          if (index != -1) {
            this.selectedRows.splice(index, 1);
          }
        }
      });
      // are all visible rows checked, then also check the "check all" checkbox
      let allChecked = true;
      visibleItems.forEach(item => {
        if (item.checked != true) allChecked = false;
      });
      this.checkedAllCostGroups = visibleItems.length > 0 && allChecked;

      this.recalcCostGroupsSum(visibleItems);
    },
    handleCellLeave(e) {
      if (!e.relatedTarget) this.toggleRowEdit(this.rowIsDirty);
    },
    loadMapping() {
      const instance = getInstance();
      instance.getTokenSilently().then(authToken => {
        this.isBusy = true;
        this.$axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
        this.$axios
          .get(`/api/projects/${projectStore.activeProject.DbId}/allocations`)
          .then(response => {
            this.items = this.toCategorizedList(response.data);
            //this.isBusy = false;
          })
          .catch(error => {
            this.$showError(this, error.toString());
            //this.isBusy = false;
          });
      });
    },
    toCategorizedList(items) {
      var currentNode = '';
      var returnValues = [];
      for (var i = 0; i < items.length; i++) {
        let currentItem = items[i];
        if (currentItem.DbId != currentNode.DbId) {
          var newNode = {
            displayName: currentItem.KkeDisplayName,
            DbId: currentItem.DbId,
            Budget: currentItem.Budget,
            Ordinal: currentItem.Ordinal,
            Locked: false,
            sumChildren: 0
          };
          returnValues.push(newNode);
          currentNode = newNode;
        }
        if (!currentNode.children) currentNode.children = [];
        if (currentItem.VeId) {
          currentNode.children.push(currentItem);
          currentNode.sumChildren += (currentItem.Ratio / 100) * currentNode.Budget;
        }
      }
      return returnValues;
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    },
    sumChildren(item, budget) {
      var sum = 0;
      for (let i = 0; i < item.children.length; i++) {
        sum += (item.children[i].Ratio / 100) * budget;
      }
      return sum;
    },
    onTabActivated(newTabIndex) {
      switch (newTabIndex) {
        case 0:
          this.loadCostGroups();
          break;
        case 1:
          this.loadMapping();
          break;
      }
    },
    loadCostGroups() {
      this.isCostGroupsTableBusy = true;
      costGroupService.getCostGroups(projectStore.activeProject.DbId, (items, err) => {
        this.isCostGroupsTableBusy = false;
        if (err) {
          return this.$showError(this, err.toString());
        }
        var allChecked = this.costGroups.length > 0;

        this.costGroups = items.map(x => {
          x.BudgetAllocated = parseFloat(x.BudgetAllocated);
          x.editMode = false;
          x.checked = this.selectedRows.find(y => y.DbId == x.DbId) != null;
          if (x.checked !== true) allChecked = false;
          return x;
        });

        if (this.filterToggle) {
          allChecked = true;
          this.costGroupsBackup = [...this.costGroups];
          this.costGroups = this.costGroups.filter(x => {
            return x.checked == true;
          });
        }

        this.isLoading = false;
        //this.$refs.tableCostGroups.$el.scrollTo({ top: AppState.budgetTableScrollPosition });
        if (AppState.scrollPosition[this.$route.path])
          this.$refs.tableCostGroups.$el.scrollTo({
            top: AppState.scrollPosition[this.$route.path][0],
            left: AppState.scrollPosition[this.$route.path][1]
          });
        setTimeout(() => {
          this.checkedAllCostGroups = allChecked;
          this.onWindowResize();
        }, 200);

        this.recalcCostGroupsSum();
      });
    },
    showNewCostGroupModal() {
      this.$bvModal.show('newCostGroupModal');
    },
    showNewAllocationUnitModal() {
      this.$bvModal.show('newAllocationUnitModal');
    },
    startProject() {
      const h = this.$createElement;
      var question = `Sie befinden sich aktuell in der Kalkulations- und Budgetierungs-Phase des Projekts und möchten in die Controlling-Phase wechseln.<br><br>
Das Projektbudget wird „eingefroren“ und kann dann nicht mehr modifiziert werden.<br><br>
Änderungen werden ab diesem Zeitpunkt mittels Projektänderungstestaten (PÄT) erfasst.<br><br>
Möchten Sie wirklich die Controlling-Phase starten?`;
      const messageVNode = h('div', { domProps: { innerHTML: question } });
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Projekt starten',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',
          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            projectService
              .start()
              .then(() => {
                this.projectStore.activeProject.State = 1;
                this.loadCostGroups();
                this.$showSuccess(this, 'Projekt starten', 'Projekt erfolgreich gestartet.', 'b-toaster-top-right');
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    revertProjectStart() {
      projectService
        .revertStart()
        .then(() => {
          this.projectStore.activeProject.State = 0;
          this.$showSuccess(
            this,
            'Projektstart zurücksetzen',
            'Projekt erfolgreich zurückgesetzt.',
            'b-toaster-top-right'
          );
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    deleteCostGroup(item) {
      if (item.Locked) {
        return this.$bvModal.msgBoxOk(
          'Die Ausgewählte Kostenkontrolleinheit kann nicht gelöscht werden, da sie gesperrt ist.',
          {
            title: 'Kostengruppe löschen',
            okTitle: 'OK',

            okVariant: 'danger',

            centered: true
          }
        );
      }
      costGroupService.getCostGroupAllocations(item.DbId).then(allocations => {
        var allocationList = '';
        allocations.forEach(allocation => {
          allocationList +=
            '<li>' +
            allocation.Ordinal +
            ' ' +
            allocation.DisplayName +
            '<span class="text-muted"> (' +
            this.$utils.numberToCurrency(parseFloat(allocation.Amount), settingsStore.settings['Centbetraege']) +
            ')</span></li>';
        });
        const h = this.$createElement;
        var question =
          'Soll die Kostengruppe "' + item.Ordinal + ' ' + item.DisplayName + '" wirklich gelöscht werden?';
        if (allocations.length > 0)
          question +=
            '<br><div class="alert alert-danger mt-2 mb-1" role="alert"><strong>Achtung:</strong> diese KKE wurde bereits budgetiert! Folgende Zuordnungen zu Vergabeeinheiten werden ebenfalls gelöscht:<br><br>' +
            allocationList +
            '</div>';
        const messageVNode = h('div', { domProps: { innerHTML: question } });
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Kostengruppe löschen',
            okTitle: 'Bestätigen',
            cancelTitle: 'Abbrechen',
            okVariant: 'danger',

            centered: true
          })
          .then(confirmed => {
            if (confirmed) {
              costGroupService.deleteCostGroup(projectStore.activeProject.DbId, item.DbId, err => {
                if (err) {
                  if (err.response) this.$showError(this, err.response.data.error);
                  else this.$showError(this, err.toString());
                  return;
                }
                //remove item from store
                this.$utils.deleteItemFromArray(this.costGroups, x => x.DbId == item.DbId);
                this.recalcCostGroupsSum();
                this.$showSuccess(this, 'Kostenkontrolleinheit löschen', 'Kostenkontrolleinheit erfolgreich gelöscht');
                if (this.costGroups.length == 0) this.checkedAllCostGroups = false;
                this.$eventBus.$emit('budget:changed');
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    deleteSelected() {
      let itemsToDelete = this.costGroups.filter(x => {
        return x.checked;
      });

      if (itemsToDelete.length == 1) {
        return this.deleteCostGroup(itemsToDelete[0]);
      }

      const h = this.$createElement;
      var question =
        'Sollen die ausgewählten ' +
        itemsToDelete.length +
        ' Kostengruppen wirklich gelöscht werden?' +
        '<br><div class="alert alert-danger mt-2 mb-1 p-2" role="alert"><strong>Achtung:</strong> Falls diese KKEs bereits auf VEs budgetiert wurden, werden die Budgetzuordnungen ebenfalls gelöscht!</div>';
      const messageVNode = h('div', { domProps: { innerHTML: question } });
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Kostengruppen löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          this.isCostGroupsTableBusy = true;
          //let count = 0;
          if (confirmed) {
            costGroupService
              .deleteCostGroups({ costGroups: itemsToDelete.map(x => x.DbId) })
              .then(result => {
                if (result.faultyCostGroups.length > 0)
                  this.$showWarning(
                    this,
                    result.faultyCostGroups.length + ' Kostenkontrolleinheit(en) konnten nicht gelöscht werden.'
                  );
                itemsToDelete.forEach(item => {
                  const wasFaulty = result.faultyCostGroups.find(x => x.costGroupId == item.DbId);
                  if (!wasFaulty) this.$utils.deleteItemFromArray(this.costGroups, x => x.DbId == item.DbId);
                });
                this.isCostGroupsTableBusy = false;
                if (this.costGroups.length == 0) {
                  this.checkedAllCostGroups = false;
                }
                this.isDeleteButtonEnabled = false;
                this.recalcCostGroupsSum();
                this.$showSuccess(
                  this,
                  'Kostenkontrolleinheit löschen',
                  result.deletedCount + ' Kostenkontrolleinheit(en) erfolgreich gelöscht.'
                );
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              })
              .finally(() => {
                this.isCostGroupsTableBusy = false;
              });
            /*
  
            */
          } else {
            this.costGroups.map(x => {
              x.checked = false;
              return x;
            });
            this.isCostGroupsTableBusy = false;
            this.isDeleteButtonEnabled = false;
            this.checkedAllCostGroups = false;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => {
            this.$eventBus.$emit('budget:changed');
          }, 400);
        });
    },
    editItem() {},
    showImportKKEModal() {
      this.$bvModal.show('ImportKKEModal');
    },
    addNewCostGroup(costGroup) {
      costGroup.editMode = false;
      costGroup.Locked = false;
      costGroup.checked = this.checkedAllCostGroups;
      this.costGroups.push(costGroup);
      this.recalcCostGroupsSum();
    },
    recalcCostGroupsSum(items) {
      /*
              for (const cg of selectedRows) {
                if (this.$refs['tableCostGroups'].filteredItems.find(x => x.DbId == cg.DbId)) {
                  // is it visible??
                  continue;
                } else {
                  this.allChecked = false;
                  x.checked = false;
                }
                // is it hidhen??
              }*/
      if (!items) items = this.costGroups;
      // uncheck not visible (filtered) items
      /*
      for (const row of this.selectedRows) {
        // is it visible?
        if (this.$refs['tableCostGroups'].filteredItems.find(x => x.DbId == row.DbId)) {
          // is it visible??yes!

          continue;
        } else {
          this.checkedAllCostGroups = false;
          row.checked = false;
          //remove from selected rows
          this.selectedRows = this.selectedRows.filter(x => x.DbId != row.DbId);
        }
      }
        */
      this.costGroupsTotal = 0;
      this.costGroupsTotalAllocated = 0;
      items.map(x => {
        this.costGroupsTotal += x.Budget * 1;
        this.costGroupsTotalAllocated += parseFloat(x.BudgetAllocated);
      });
      this.displayedItemsCount = items.length;
    },
    insertNewRecord() {
      if (!this.$refs.newCostGroupRowForm.checkValidity()) {
        return this.$refs.newCostGroupRowForm.reportValidity();
      }
      // check if kke id or displayname already exists
      for (const item of this.costGroups) {
        if (item.Ordinal == this.rowDataNewCostGroup.Ordinal) {
          return this.$showError(
            this,
            'FEHLER: eine Kostenkontrolleinheit mit der KKE "' + item.Ordinal + '" existiert bereits.',
            'Kostenkontrolleinheit anlegen'
          );
        }
        if (item.DisplayName == this.rowDataNewCostGroup.DisplayName)
          this.rowDataNewCostGroup.DisplayName = this.rowDataNewCostGroup.DisplayName + ' (1)';
      }
      this.rowDataNewCostGroup.Budget = parseFloat(this.rowDataNewCostGroup.Budget);
      costGroupService.createNewCostGroup(projectStore.activeProject.DbId, this.rowDataNewCostGroup, (err, result) => {
        if (err) {
          console.log('err', err);
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        } else {
          this.$showSuccess(this, 'Kostenkontrolleinheit anlegen', 'Kostenkontrolleinheit erfolgreich angelegt.');
          this.addNewCostGroup(result);
          this.rowDataNewCostGroup = {};
          this.$nextTick(() => {
            this.scrollToNewRowAndFocus();
          });
        }
      });
    },
    downloadAsXLS() {
      this.isLoading = true;
      costGroupService.downloadAsXLS().finally(() => {
        this.isLoading = false;
      });
    },
    showMultiAllocationModal() {
      this.$bvModal.show('multiAllocationModal');
    },
    bookMultiAllocations(VeDbId) {
      const costGroupList = this.costGroups
        .filter(x => x.checked)
        .map(x => {
          x = x.DbId;
          return x;
        });

      const workItem = {
        VeDbId,
        costGroupList
      };
      this.costGroups.map(x => {
        x.checked = false;
        return x;
      });
      this.isCostGroupsTableBusy = false;
      this.isDeleteButtonEnabled = false;
      this.checkedAllCostGroups = false;
      costGroupService
        .allocateCostGroupToMultipleAllocationUnits(workItem)
        .then(() => {
          this.$showSuccess(this, 'Ausgewählte KKE einer VE zuweisen', 'Zuweisungen erfolgreich erstellt.');
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.loadCostGroups();
        });
    },
    onCheckAllCostGroupsChange() {
      this.isDeleteButtonEnabled = this.checkedAllCostGroups;

      this.$refs['tableCostGroups'].filteredItems.map(x => {
        return (x.checked = this.checkedAllCostGroups);
      });
      this.selectedRows = this.costGroups.filter(x => x.checked == true);
    },
    onCheckCostGroupItemChange(item) {
      this.isDeleteButtonEnabled = false;

      this.selectedRows = this.costGroups.filter(x => x.checked == true);

      for (let i = 0; i < this.costGroups.length; i++) {
        if (this.costGroups[i].checked) {
          this.isDeleteButtonEnabled = true;
          break;
        }
      }
      if (!item.checked) {
        return (this.checkedAllCostGroups = false);
      }

      for (let i = 0; i < this.costGroups.length; i++) {
        if (!this.costGroups[i].checked) {
          return (this.checkedAllCostGroups = false);
        }
      }

      this.checkedAllCostGroups = true;
    },
    onImportSuccess() {
      this.loadCostGroups();
      this.$eventBus.$emit('budget:changed');
    },
    scrollToNewRowAndFocus(/*focusAfterScroll = null*/) {
      this.$refs.newCostGroupRowKKE.$el.focus({ preventScroll: true });
      var element = document.querySelector('.b-table-sticky-header');
      element.scrollBy({
        top: 5000000, // Scroll the the end of the tabele's height
        behavior: 'smooth'
      });
    },
    toggleRowEdit(item, fieldToFocus = null) {
      if (item && item.editMode && this.rowIsDirty) {
        return this.updateCostGroupItem(this.rowIsDirty);
      }
      if (projectStore.activeProject.State == 1 || !(this.$root.$user.isPlaner || this.$root.$user.isAdmin)) return;
      // if clicking on another row, remove editMode from all rows that eventually were in editMore before
      for (const costGroup of this.costGroups.filter(x => x.editMode)) {
        costGroup.editMode = false;
      }
      this.rowIsDirty = null;
      if (!item) {
        return;
      }

      item.editMode = !item.editMode;
      if (item.editMode) {
        // we go into edit mode

        // create a backup of the current row's data. if the user cancels editing (esc, x-icon), revert to the backup
        this.rowDataBackup = { ...item };
        this.$nextTick(() => {
          // if the user clicked on a specific field, then we focus on that field
          if (item.Locked) {
            this.$refs['displayNameField-' + item.DbId].focus();
          } else if (fieldToFocus) {
            this.$refs[fieldToFocus + '-' + item.DbId].focus();
          } else this.$refs['ordinalField-' + item.DbId].focus();
        });
      } else {
        item.Budget = parseFloat(item.Budget);
      }
    },
    cancelRowEdit(item) {
      item.editMode = false;
      // user has canceled editing, so revert value fields to the state, they had before editMode.
      item.Ordinal = this.rowDataBackup.Ordinal;
      item.DisplayName = this.rowDataBackup.DisplayName;
      item.Budget = this.rowDataBackup.Budget;
      this.rowDataBackup = null;
    },
    updateCostGroupItem(item) {
      const input = this.$refs['ordinalField-' + item.DbId];
      // ordinals must be unique: do we already have that ordinal?
      for (const otherItem of this.costGroups) {
        if (otherItem.Ordinal == item.Ordinal && otherItem.DbId != item.DbId) {
          input.setCustomValidity('KKE muss eindeutig sein');
          input.reportValidity();
          return;
        }
      }
      item.editMode = false;
      item.Budget = parseFloat(item.Budget);
      return costGroupService
        .updateCostGroup(item)
        .then(() => {
          //alert(item.DisplayName);
          //console.log('zzzzz', item, itm);
          this.$showSuccess(
            this,
            'Kostenkontrolleinheit bearbeiten',
            'Kostenkontrolleinheit "' + item.Ordinal + ' ' + item.DisplayName + '" erfolgreich aktualisiert.'
          );
          this.recalcCostGroupsSum();
          this.$eventBus.$emit('budget:changed');
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
          this.loadCostGroups();
        });
    },
    navigateTo(item) {
      if (item.editMode) return; // cancel navigation, if item is in edit mode
      this.$router.push('/budget/' + item.DbId);
    },
    onWindowResize() {
      const totalHeight = window.innerHeight;
      const budgetSummarySection = document.querySelector('#budgetSummaryTable-Budgetierung');
      const headerHeight = this.$refs.pageHeader.offsetHeight;
      if (headerHeight == 0) return;
      const tableHeight = totalHeight - headerHeight - budgetSummarySection.offsetHeight - 65;
      this.tableHeight = tableHeight + 'px';
      /* console.log('header', headerHeight);
      console.log('budgetSummarySection', budgetSummarySection.offsetHeight);
      console.log('Resized to', this.tableHeight); */
    },
    filterRecords() {
      if (!this.filterToggle) {
        this.filterToggle = true;
        this.costGroupsBackup = [...this.costGroups];
        this.costGroups = this.costGroups.filter(x => {
          return x.checked == true;
        });
        this.checkedAllCostGroups = true;
      } else {
        this.filterToggle = false;
        this.costGroups = this.costGroupsBackup;

        this.checkedAllCostGroups = this.selectedRows.length == this.costGroups.length;
      }
      this.recalcCostGroupsSum(this.costGroups);
    }
  }
};
</script>
<style>
.bg-transparent {
  background-color: var(--bauvisor-light) !important;
}

.costGroupTable {
  overflow: none !important;
}
/*
table tfoot {
  position: sticky;
}
table tfoot {
  inset-block-end: 0; 
  background-color: white;
  z-index: 1000;
}*/
</style>
